import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UseDeleteAreaTypesMutationProps = {
	onSettled: () => void
}

export const useDeleteAreaTypesMutation = ({ onSettled }: UseDeleteAreaTypesMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: boothTypesDeleteMutation } = useMutation({
		mutationFn: ({ ids }: { ids: number[] }) => {
			return axiosPrivate.post(apiRoutes.areaTypeBulkDelete, { ids: ids })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.boothTypes.all })
			useToast({
				type: 'success',
				message: t('Area types deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled
	})

	return {
		boothTypesDeleteMutation
	}
}
